import React, { useState } from 'react'
import './Contactform.css'
import emailjs from 'emailjs-com';
import './Button.css'

export default function Contactform() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const submitInfo = () => {
        console.log(name + email + message);

        const emailContent = {
            name: name,
            email: email,
            message: message,
        };

        emailjs.send('service_49ej4v8', 'template_739gbrm', emailContent, '-a5woYSdy9K9UvjXk')
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });

        setName('')
        setEmail('')
        setMessage('')
    }
  return (
    <div className="form-group-container" id='contact'>
      <form>
        <div className="form-group">
            <div className="form-group-divider-container">
                <div className="form-group-divider">
                    <div className="footer-link-items">
                        <h2>Contact Info</h2>
                        <div><i class="fa-solid fa-location-dot"></i>Cagayan de Oro, Philippines</div>
                        <div><i class="fa-solid fa-phone"></i> +63 936 726 4041</div>
                        <div><i class="fa-solid fa-envelope"></i> kobechristian.dahiroc@gmail.com</div>
                    </div>
                </div>
                <div className="form-group-divider">
                    <div className="form-group-divider-inside">
                        <h2>Hi, it's me,</h2>
                        <div className="form-group-divider-inside-position">
                            <input type='text' className='form__input' id='name' name='name' value={name} onChange={(e) => setName(e.target.value)} autoComplete="off" placeholder=' ' required/>
                            <label htmlFor='name'>Your Name</label>
                        </div>
                        <div className="form-group-divider-inside-position">
                            <input type='text' className='form__input' id='email' name='email' value={email}  onChange={(e) => setEmail(e.target.value)} autoComplete="off" placeholder=' ' required/>
                            <label htmlFor='email'>Your Email</label>
                        </div>
                    </div>
                </div>
                <div className="form-group-divider">
                    <div className="form-group-divide-insider">
                        <h2>Write a message</h2>
                        <div className="form-group-divider-inside-position"> 
                            <textarea type='text' className='form__input' id='message' name='message' value={message} onChange={(e) => setMessage(e.target.value)} autoComplete="off" placeholder=' ' required/>
                            <label htmlFor='Message' >Message</label>
                        </div>
                    </div>
                </div>
            </div>
            <div className="form-group-divider-button">
                <a className="btn btn--primary" buttonStyle="primary" onClick={submitInfo}>Send</a>
            </div>
        </div>
      </form>
    </div>
  )
}
